import GoogleMapsApiLoader from 'google-maps-api-loader';
import googleMapTheme from './helpers/GoogleMapTheme';

export default class googleMap {

  constructor() {
    this.settings = {
      mapSelector: '.map',
      mapEventSelector: '.event-map',
    };
    this.mapOptions = {
      zoom: 17,
      styles: googleMapTheme,
      scrollwheel: false,
      disableDefaultUI: false,
    }
    this.mapEventOptions = {
      zoom: 17,
      styles: googleMapTheme,
      scrollwheel: false,
      disableDefaultUI: true,
    }
    GoogleMapsApiLoader({
      libraries: ['places'],
      apiKey: 'AIzaSyD-3ktOyXIIqvESt1JqkfFoFu3I_wnzHBo',
    }).then(() => {
      $(this.settings.mapSelector).map((index, element) => {
        const $element = $(element);
        this.createMap($element);
      });
        $(this.settings.mapEventSelector).map((index, element) => {
          const $element = $(element);
          this.createMap($element);
        });
    });
    // (err) => {
    //   console.error(err);
    // });
  }

  createMap($el) {
    /*global google*/

    const $markers = [{lat: parseFloat($el.attr('data-lat')), lng: parseFloat($el.attr('data-lng'))}];
    const mapPosition = {lat: parseFloat($el.attr('data-lat')), lng: parseFloat($el.attr('data-lng'))};

    let args;
    if ($el.hasClass('map')) {
      args = this.mapOptions;
    } else if ($el.hasClass('event-map')) {
      args = this.mapEventOptions;
    }

    args.center = mapPosition;
    args.mapTypeId = google.maps.MapTypeId.ROADMAP;
    const map = new google.maps.Map($el[0], args);

    map.markers = [];
    if ($markers) {
      $markers.map((marker) => {
        this.addMapMarker(marker, map);
      });
    }

    const center = mapPosition;
    google.maps.event.addDomListener(window, 'resize', () => {
      google.maps.event.trigger(map, 'resize');
      map.setCenter(center);
    });

    return map;
  }

  addMapMarker(data, map) {
    const latlng = {lat: parseFloat(data.lat), lng: parseFloat(data.lng)};
    const marker = new google.maps.Marker({
      position: latlng,
      animation: google.maps.Animation.DROP,
    });
    marker.setMap(map);
    map.markers.push(marker);
  }

}



// WEBPACK FOOTER //
// ./scripts/googleMap.js